import React, { useState } from 'react';
import '../styles/StudyWithGuideLayout.css';

export default function StudyWithGuideLayout({ children, onClose }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="study-layout">
      {/* Left: PDF Guide */}
      <div className="study-guide-panel">
        <div className="study-guide-header">
          <h3>📖 CDL Study Guide</h3>
          <button className="study-close-btn" onClick={onClose} title="Close Guide">
            ✕
          </button>
        </div>
        <div className="study-guide-content">
          <button
            className="study-toggle-sidebar"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            title="Toggle sidebar"
          >
            ☰
          </button>
          <iframe
            className="study-pdf-iframe"
            src="/CDL-Study-Guide.pdf#toolbar=1&navpanes=0&scrollbar=1"
            title="CDL Study Guide"
            allow="fullscreen"
          />
        </div>
      </div>

      {/* Right: Quiz/Practice/Exam */}
      <div className="study-quiz-panel">
        <div className="study-quiz-header">
          <h3>📝 Practice/Exam</h3>
        </div>
        <div className="study-quiz-content">
          {children}
        </div>
      </div>
    </div>
  );
}
